import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sn-header-field',
  templateUrl: './header-field.component.html',
  styleUrls: ['./header-field.component.css', '../../beasley/beasley.component.css']
})
export class HeaderFieldComponent implements OnInit {
    @Input() item:any;
    @Input() field:any;
    @Input() data_filters:any;
    @Output() public onColumnSortEvent = new EventEmitter();
    @Output() public onColumnFilterEvent = new EventEmitter();
    
    label:string;
    header_class:string;
    enable_sorting:boolean;
    enable_filtering:boolean;
    is_column_filter: boolean = false;
    data_filter: any[] = null;
    current_filter: any;

    constructor() { }

    ngOnInit() {
        if (this.field) {
            this.label = this.field.label;
            this.enable_sorting = this.field.enable_sorting;
            this.enable_filtering = this.field.enable_filtering;
        }
    }

    isFilteringEnabled() {
        return this.enable_filtering && this.getDataFilter();
    }

    getDataFilter() {
        if (this.data_filter == null && this.data_filters[this.field.key]) this.data_filter = this.data_filters[this.field.key];
        return this.data_filter;
    }
    
    getHeaderClass() {
        if (this.enable_sorting) {
            this.header_class = "sn-sortable";
            if (this.field.sort_active) this.header_class += ' active';
        }
        return this.header_class;
    }

    onSort(e) {
        if (this.enable_sorting) {
            if (this.onColumnSortEvent) this.onColumnSortEvent.emit({ field: this.field, event: e });
        }
    }

    onFilter(filter) {
        if (this.enable_filtering) {
            this.current_filter = filter;
            if (this.onColumnFilterEvent) this.onColumnFilterEvent.emit({ field: this.field, event: filter });
        }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/common/header-field/header-field.component.ts